module.exports = __webpack_public_path__ + "img/cart-empty.2fd5e94d.png";